export default __webpack_public_path__ + "static/media/You_re Soft.8eefd39e.png";